// extracted by mini-css-extract-plugin
export var csatScore = "_ld-5";
export var header = "_ld-1";
export var panelWrapper = "_ld-2";
export var postPreview = "_ld-3";
export var rightContent = "_ld-0";
export var wrappingText = "_ld-4";